import { isLocale, Locale } from "./locales";
import { isSite, Site } from "./site";

type StoryblokSlug = `${Locale}/${Site}/${string}`;

export const isStoryblokSlug = (str: string): str is StoryblokSlug => {
  const [locale, site] = str?.split("/");
  return isLocale(locale) && isSite(site);
};
